import React, { useEffect, useRef, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
// import ascasLogo from "../../assets/images/ascas.svg";
import "./embryologist.scss";

const EMBRO_URL = process.env.REACT_APP_EMBRO_URL || (process.env.NODE_ENV === 'development' ? "http://localhost:5173" : "/embryology");
const EMBRO_ORIGIN = EMBRO_URL.startsWith("http") ? new URL(EMBRO_URL).origin : window.location.origin;

const EMBRYOLOGY_ROUTE_LABELS = {
  "/": "Embryology Dashboard",
  "/andrology": "Andrology",
  "/opu": "OPU Records",
  "/embryo-tracking": "Embryo Tracking",
  "/transfer": "Embryo Transfer",
  "/cryo": "Cryopreservation",
  "/arp-report": "Embryology ART Report",
  "/clinical-art-report": "Clinical ART Report",
  "/reports": "Reports & Summaries",
  "/embryology-records": "Embryology Records",
  "/embryology-register": "Embryology Register",
};

function Embryologist() {
  const iframeRef = useRef(null);
  const location = useLocation();
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const [isLoading, setIsLoading] = useState(true);

  // Map HMS route to embro internal route
  // e.g. /embryologist/opu -> /opu
  const embroPath = useMemo(() => {
    const path = location.pathname.replace("/embryologist", "") || "/";
    return path;
  }, [location.pathname]);

  const iframeSrc = `${EMBRO_URL}${embroPath}`;
  const loadingLabel = EMBRYOLOGY_ROUTE_LABELS[embroPath] || "Embryology";

  useEffect(() => {
    setIsLoading(true);
  }, [iframeSrc]);

  useEffect(() => {
    const handleReady = (event) => {
      if (
        event.origin === EMBRO_ORIGIN &&
        event.source === iframeRef.current?.contentWindow &&
        event.data?.type === "EMBRYOLOGY_READY"
      ) {
        setIsLoading(false);
      }
    };

    window.addEventListener("message", handleReady);
    return () => window.removeEventListener("message", handleReady);
  }, []);

  // Send auth token to iframe after it loads
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const sendAuth = () => {
      const token = localStorage.getItem("token");
      const userdata = localStorage.getItem("userdata");
      const branch = localStorage.getItem("selectedBranch") || localStorage.getItem("branch");
      try {
        iframe.contentWindow.postMessage(
          {
            type: "HMS_AUTH_TOKEN",
            token,
            user: userdata ? JSON.parse(userdata) : null,
            branch,
          },
          EMBRO_ORIGIN
        );
      } catch (e) {
        // ignore if iframe not ready
      }
    };

    iframe.addEventListener("load", sendAuth);
    return () => iframe.removeEventListener("load", sendAuth);
  }, [iframeSrc]);

  return (
    <div className={`embryologist-container ${sideactive ? "sidebar-open" : "sidebar-closed"}`}>
      {isLoading && (
        <div className="embryologist-loader" role="status" aria-live="polite" aria-label={`Loading ${loadingLabel}`}>
          <div className="embryologist-loader-card">
            {/* <img src={ascasLogo} alt="ASCAS Logo" className="embryologist-loader-logo" /> */}
            <span className="embryologist-loader-spinner" aria-hidden="true" />
            <strong>{`Loading ${loadingLabel}...`}</strong>
            <span>Please wait while the clinical workspace is prepared.</span>
          </div>
        </div>
      )}
      <iframe
        ref={iframeRef}
        src={iframeSrc}
        title="IVF Lab"
        className="embryologist-iframe"
      />
    </div>
  );
}

export default Embryologist;
